var React = require('react');

function VolumeOff (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"volume"},[React.createElement("path",{"id":"Vector","d":"M3 10.0003V14.0003C3 14.5503 3.45 15.0003 4 15.0003H7L10.29 18.2903C10.92 18.9203 12 18.4703 12 17.5803V6.41026C12 5.52026 10.92 5.07026 10.29 5.70026L7 9.00026H4C3.45 9.00026 3 9.45026 3 10.0003Z","fill":"white","key":0}),React.createElement("path",{"id":"Vector_2","d":"M19.6361 14L15.2725 10M19.6361 10L15.2725 14","stroke":"white","strokeWidth":"2","strokeLinecap":"round","key":1})]));
}

VolumeOff.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = VolumeOff;

VolumeOff.default = VolumeOff;
